export default () => {
  $(document).ready(function() {
    const expandButtons = $('.community-landing-three-columns-action .btn').toArray();
    const columns = $('.community-landing-three-columns-column').toArray();

    let shouldReRender = false;

    if (columns.length === 0) {
      return;
    }

    function toggleAllButtons(newState) {
      expandButtons.forEach((button) => button.dataset.expanded = newState);
    }

    function toggleButtonsAndColumns() {
      expandButtons.forEach((button) => button.dataset.expanded = 'false');
      columns.forEach((column) => column.dataset.expanded = 'false');
    }

    expandButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const { control, expanded } = event.target.dataset;

        const newState = expanded !== 'true';
        event.target.dataset.expanded = newState;

        if (control === 'all') {
          columns.forEach((column) => column.dataset.expanded = newState);
          toggleAllButtons(newState);
        } else {
          const target = $(`[data-title='${control}']`)[0];
          target.dataset.expanded = newState;
        }
      });
    });

    const toolTipElements = document.querySelectorAll('.-tooltip');
    const toolTipContentContainer = document.querySelectorAll('.community-landing-three-columns-column-content');

    function matchTooltipHeight(elements, shouldUpdateVar) {
      let maxHeight = 0;

      // Resetting
      elements.forEach((element) => {
        element.style.height = 'fit-content';
        if (shouldUpdateVar) {
          element.style.setProperty('--max-height', '0');
        }
      });

      // Loop through the elements and find the tallest one
      elements.forEach((element) => {
        const elementHeight = element.offsetHeight;
        if (elementHeight > maxHeight) {
          maxHeight = elementHeight;
        }
      });

      // Apply the tallest height to all elements
      elements.forEach((element) => {
        if (shouldUpdateVar) {
          element.style.setProperty('--max-height', `${maxHeight}px`);
          element.style.setProperty('--max-height', `${maxHeight}px`);
        } else {
          element.style.height = `${maxHeight}px`;
        }
      });
    }

    matchTooltipHeight(toolTipElements);
    matchTooltipHeight(toolTipContentContainer, true);

    window.addEventListener('resize', () => {

      matchTooltipHeight(toolTipElements);
      matchTooltipHeight(toolTipContentContainer, true);

      if (columns[0].dataset.showDetails === 'false') {
        return;
      }

      if (window.innerWidth >= 900) {
        if (shouldReRender) {
          toggleButtonsAndColumns();
          shouldReRender = false;
        }
      } else {
        shouldReRender = true;
      }
    });
  });
};
